import OtherWindowAutoSelectDetailChart from './OtherWindowAutoSelectDetailChart';

export default OtherWindowAutoSelectDetailChart;
